import { EditOutlined, VisibilityOutlined } from "@mui/icons-material";
import {
  Box,
  Button,
  ButtonBase,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  Typography,
} from "@mui/material";
import { CssTextField } from "src/qubCommon/Inputs";

export const ReviewCommentsCell = ({
  value,
  canEdit,
  rowLabel,
  editorOrder,
  onOpen,
}) => {
  const actionLabel = canEdit ? "Επεξεργασία" : "Προβολή";

  return (
    <Tooltip title={`${actionLabel} σχολίων ελέγχου`}>
      <ButtonBase
        aria-label={`${actionLabel} σχολίων ελέγχου: ${rowLabel}`}
        data-expense-review-editor={canEdit ? "true" : undefined}
        data-expense-review-editor-order={canEdit ? editorOrder : undefined}
        data-expense-review-editor-type={canEdit ? "statusComments" : undefined}
        onClick={(event) => {
          event.stopPropagation();
          onOpen();
        }}
        onMouseDown={(event) => event.stopPropagation()}
        onKeyDown={(event) => event.stopPropagation()}
        sx={{
          alignItems: "center",
          color: canEdit ? "text.primary" : "text.secondary",
          display: "flex",
          fontSize: 13,
          gap: 0.75,
          height: "100%",
          justifyContent: "space-between",
          px: 0.75,
          textAlign: "left",
          width: "100%",
          "&:focus-visible": {
            outline: "2px solid",
            outlineColor: "primary.main",
          },
        }}
      >
        <Box
          component="span"
          sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
        >
          {value || (canEdit ? "  " : "-")}
        </Box>
        {canEdit ? (
          <EditOutlined aria-hidden="true" sx={{ flexShrink: 0, fontSize: 16 }} />
        ) : (
          <VisibilityOutlined aria-hidden="true" sx={{ flexShrink: 0, fontSize: 16 }} />
        )}
      </ButtonBase>
    </Tooltip>
  );
};

const ReviewCommentsDialog = ({
  selection,
  canEdit,
  onChange,
  onClose,
  onApply,
  onExited,
}) => (
  <Dialog
    open={Boolean(selection)}
    onClose={onClose}
    fullWidth
    maxWidth="md"
    disableRestoreFocus
    TransitionProps={{ onExited }}
    onKeyDown={(event) => {
      if (
        canEdit &&
        selection &&
        event.key === "Enter" &&
        (event.ctrlKey || event.metaKey) &&
        !event.isComposing
      ) {
        event.preventDefault();
        event.stopPropagation();
        onApply();
      }
    }}
  >
    <DialogTitle variant="h4">Σχόλια Ελέγχου - {selection?.rowLabel}</DialogTitle>
    <DialogContent dividers>
      {canEdit ? (
        <CssTextField
          autoFocus
          fullWidth
          multiline
          minRows={8}
          maxRows={18}
          variant="standard"
          size="small"
          fixedPadding={8}
          InputProps={{ disableUnderline: true }}
          inputProps={{ "aria-label": "Σχόλια Ελέγχου" }}
          value={selection?.draft ?? ""}
          onChange={(event) => onChange(event.target.value)}
        />
      ) : (
        <Typography
          component="div"
          sx={{
            minHeight: 120,
            overflowWrap: "anywhere",
            whiteSpace: "pre-wrap",
          }}
        >
          {selection?.draft || "Δεν υπάρχει σχόλιο ελέγχου."}
        </Typography>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>{canEdit ? "Άκυρο" : "Κλείσιμο"}</Button>
      {canEdit && (
        <Button
          variant="contained"
          onClick={onApply}
          aria-keyshortcuts="Control+Enter Meta+Enter"
        >
          Εφαρμογή (Ctrl+Enter)
        </Button>
      )}
    </DialogActions>
  </Dialog>
);

export default ReviewCommentsDialog;
